// extracted by mini-css-extract-plugin
export default {"popoverMain":"Popover_popoverMain__ZJzGq","ant-popover-arrow":"Popover_ant-popover-arrow__5yOYS"};